import { LOGO } from "../../layout/style";
import Logo from '../../assets/image/logo/Octaplex Logo.png';
import { Button, Col, Flex, Input, Layout, Menu, Row, Space } from 'antd'
import { Outlet } from "react-router-dom";
import { AppstoreOutlined, MailOutlined, SettingOutlined, DashboardOutlined, BulbOutlined, CopyOutlined } from '@ant-design/icons';
const { Header, Sider, Content } = Layout;
const items = [
    {
        key: 'sub1',
        icon: <DashboardOutlined />,
        label: 'Navigation One',
        children: [
            {
                key: '1-1',
                label: 'Analyze',
                type: 'group',
                children: [
                    {
                        key: '1',
                        label: 'Home',
                    },
                    {
                        key: '2',
                        label: 'Dashboard',
                    },
                    {
                        key: '3',
                        label: 'Maps',
                    },
                    {
                        key: '4',
                        label: 'Data',
                    },
                ],
            },
           
        ],
    },

    {
        key: 'sub2',
        icon: <BulbOutlined />,
        label: 'Navigation One',
        children: [
            {
                key: '2-1',
                label: 'Predict',
                type: 'group',
                children: [
                    {
                        key: '5',
                        label: 'ML',
                    },
                    {
                        key: '6',
                        label: 'Scenarios',
                    },
                   
                ],
            },
           
        ],
    },

    {
        key: 'sub3',
        icon: <CopyOutlined />,
        label: 'Navigation One',
        children: [
            {
                key: '3-1',
                label: 'Data Modal',
                type: 'group',
                children: [
                    {
                        key: '7',
                        label: 'Entities',
                    },
                    {
                        key: '8',
                        label: 'Signals',
                    },
                    {
                        key: '9',
                        label: 'Sources',
                    },
                    
                    
                   
                ],
            },
           
        ],
    },




];

const onClick = (e) => {
    console.log('click', e);
};

const RouteStyleTwo = () => (
    <Layout style={{ height: "100svh", overflowY: "auto" }}>
        <Flex vertical={false}>
            <Menu
                onClick={onClick}
                style={{
                    height: '100vh',
                    padding: "0 10px",
                    overflowY: "auto",
                    alignContent: 'center'
                }}
                mode="vertical"
                items={items}
                inlineCollapsed={true}
            />
            <Content style={{
                overflowY: "auto",
                height: '100vh',
                padding: 16,
            }}>
                <Outlet />
            </Content>
        </Flex>
    </Layout>
);

export default RouteStyleTwo;